(function (window, $) {
    'use strict';

    const DEBOUNCE  = 200;
    const SHOW_LOGS = true;
    const log = (...a) => SHOW_LOGS && console.log('[searchpromp]', ...a);
    const isMobileSafe = () => typeof isMobile === 'function' && isMobile();

    let lastQueryId = 0;

    const searchpromp = {
        timeoutId: null,
        request:   null,

        _debounce(fn, d = DEBOUNCE) {
            clearTimeout(this.timeoutId);
            this.timeoutId = setTimeout(fn, d);
        },

        init() {
            if (!$('.search-promp').length) {
                $('<div class="search-promp" style="display:none"></div>')
                    .appendTo('.main-search');
            }

            $('.search-input')
                .on('keyup', (e) => {
                    this._debounce(() => {
                        const v = $(e.currentTarget).val().trim();
                        if (this.request) this.request.abort();
                        v.length > 1 ? this.startSearch(v)
                            : $('.search-promp').slideUp('fast');
                    });
                })
                .on('focus',  function () { $(this).trigger('keyup'); })
                .on('focusout', () => setTimeout(() => $('.search-promp').slideUp('fast'), 150));
        },

        /* ---------------- AJAX ---------------- */
        startSearch(term) {
            const qId = ++lastQueryId;

            this.request = $.ajax({
                url:  window.elastic,
                type: 'POST',
                dataType: 'json',
                data: { search_word: term },
            })
                .done((res = {}) => {

                    if (qId !== lastQueryId) { log('старый ответ, игнор'); return; }
                    if (res.error)           { log('ответ с ошибкой');    return; }

                    const products   = Array.isArray(res.products)   ? res.products   : [];
                    const categories = Array.isArray(res.categories) ? res.categories : [];
                    const brands     = Array.isArray(res.brands)     ? res.brands     : [];

                    const catMax   = isMobileSafe() ? Math.min(categories.length, 5) : categories.length;
                    const brandMax = isMobileSafe() ? Math.min(brands.length, 5)     : brands.length;

                    let html = '';

                    html += '<div><p>Produkty</p>';
                    if (products.length) {
                        html += '<ul>';
                        products.forEach(p => {
                            const cls = [p.last && 'lastSearch', p.highlight && 'check-find'].filter(Boolean).join(' ');
                            html += `<li><a class="${cls}" href="${p.url_href}">${p.show_title}</a></li>`;
                        });
                        html += '</ul></div>';
                    } else { html += '<p class="empty-block">Brak</p></div>'; }

                    html += '<div><p>Kategorie</p>';
                    if (categories.length) {
                        html += '<ul>';
                        categories.slice(0, catMax).forEach(c => {
                            html += `<li data-type="${c.source}"><a href="${c.url_href}">${c.breadcrumbs}</a><span class="search-count">${c.amount}</span></li>`;
                        });
                        html += '</ul></div>';
                    } else { html += '<p class="empty-block">Brak</p></div>'; }

                    html += '<div><p>Marki</p>';
                    if (brands.length) {
                        html += '<ul>';
                        brands.slice(0, brandMax).forEach(b => {
                            html += `<li><a href="/szukaj/${term}?brand=${b.name}">${b.breadcrumbs}</a> <span class="search-count">${b.amount}</span></li>`;
                        });
                        html += '</ul></div>';
                    } else { html += '<p class="empty-block">Brak</p></div>'; }

                    $('.search-promp')
                        .html(html)
                        .stop(true, true)
                        .slideDown({
                            duration: 'fast',
                            start() { $(this).css({ display: isMobileSafe() ? 'block' : 'flex' }); },
                        });
                })
                .fail((_, status) => status !== 'abort' && console.error('ajax error', status));
        },
    };

    window.searchpromp = searchpromp;
    $(searchpromp.init.bind(searchpromp));

})(window, jQuery);
